import { render } from "./ProfileCard.vue?vue&type=template&id=d1275460&ts=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=d1275460&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__